<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card>
            <span v-if="org!=null">
                <center>
                    <h3>{{org.name}}</h3>
                </center>
            </span>
            <v-card-text>
                <v-row>
                     <template v-if="stud!=null">
                            <!-- <v-card class="mx-auto"  >
                                <!-- <v-img v-if="icard==null" src="https://volp4images.s3.ap-south-1.amazonaws.com/client/img_avatar.png" height="50%"></v-img>
                                <v-img v-else :src="icard" height="50%"></v-img> -->

                                <!-- <v-card-title>{{stud.name}}</v-card-title>

                                <v-card-subtitle>
                                    Enrollment No : <b>{{stud.registration_number}}</b><br />
                                    Program : <b>{{stud.program}}</b>
                                </v-card-subtitle>
                            </v-card> --> 
                        </template>
                </v-row>
                <v-row>
                    <v-col md="12" sm="12">
                        <!-- <v-card-title>Student Exam</v-card-title> -->
                        <!-- <hr class="new5" /> -->
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <!-- <th class="text-left">Course</th> -->
                                        <th class="text-left">Starts On</th>
                                        <th class="text-left">Ends On</th>
                                        <th class="text-left" style="color: blue;">Total Question</th>
                                        <!-- <th class="text-left" style="color: blue;">Question Allocated</th> -->
                                        <th class="text-left">Marks</th>
                                        <!-- <th class="text-left" style="color: blue;">Remark</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in exam_course_data" :key="index" v-bind:class="{'bg':(item.total_questions !==item.ques_alloted)}">
                                        <!-- <td>{{ item.course_code }} {{ item.course_name }}</td> -->
                                        <td>{{ item.start_date }}</td>
                                        <td>{{ item.end_date }}</td>
                                        <td>{{ item.total_questions }}</td>
                                        <!-- <td>{{ item.ques_alloted }}</td> -->
                                        <td>{{ item.marks }}</td>
                                        <!-- <td v-if="item.total_questions==item.ques_alloted"><v-icon color="success">mdi-checkbox-marked-circle</v-icon></td>
                                        <td v-else class="blink_me">Please contact examiner</td> -->
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <br />
                        <v-card-title>Read all the instructions carefully and then click on "Start Exam".</v-card-title>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr class="trclass" color="#FFF">
                                        <th class="text-left trclass" color="#FFF">Sr.No</th>
                                        <th class="text-left">Instruction</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="inst in exam_inst" :key="inst">
                                        <td>{{ inst.srno }}</td>
                                        <td>{{ inst.instruction }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                    <!-- <v-col md="4" sm="4">
                        <template v-if="stud!=null">
                            <v-card class="mx-auto" max-width="344" style="margin-top: 33px;">
                                <v-img v-if="icard==null" src="https://volp4images.s3.ap-south-1.amazonaws.com/client/img_avatar.png" height="50%"></v-img>
                                <v-img v-else :src="icard" height="50%"></v-img>

                                <v-card-title>{{stud.name}}</v-card-title>

                                <v-card-subtitle>
                                    User Name : <b>{{stud.registration_number}}</b><br />
                                    Program : <b>{{stud.program}}</b>
                                </v-card-subtitle>
                            </v-card>
                        </template>
                    </v-col> -->
                </v-row>
                <v-row v-if="exam_instructions!=null">
                    <v-col cols="12" md="12" sm="12">
                        <center><h3>Instructions for Exam</h3></center>
                        <ol>
                            <li v-for="inst in exam_instructions" :key="inst.id">{{inst.instruction}}</li>
                        </ol>
                    </v-col>
                </v-row>

                <v-row align="center" justify="center" v-if="exam_course_data!=null">
                    <!-- <v-btn :loading="loader" @click="checkExam();" color="success" rounded>Start Exam</v-btn>  -->
                    <!-- checkExam method call in  locatorButtonPressed by vrushali-->
                    <!-- <v-btn class="mr-1" @click="capture();" color="success" rounded>Capture Photo</v-btn> -->
                    <v-btn class="ml-1" :loading="loader" @click="locatorButtonPressed();"  style="color:white;background-color:#F05A2B" rounded>Start Exam</v-btn>
                </v-row>
            </v-card-text>
        </v-card>
        <template>
            <div class="text-center">
                <v-dialog v-model="dialog" width="500">
                    <v-card>
                        <v-card-text style="text-align: center; padding: 20px; color: red; font-size: 16px;"> {{msg}} </v-card-text>
                        <v-card-actions style="justify-content: center;">
                            <v-btn class="button" @click="dialog = false">
                                OK
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        data: () => ({
            dialog: false,
            loader: false,
            msg: "",
            snackbar_msg: "",
            snackbar: false,
            color: "",
            org: null,
            icard: null,
            //
            stud: null,
            col_list: null,
            exam_instructions: null,
            timer: "",
            exam_course_data: null,
            ettid_list: null,
            exam_inst: null,
            longitude:null,
            latitude:null,
            whiteboard_config : false,
            calculator_config : false,
            //by vrushali
            learner:null,
            TAB_SWITCHING:null,

            
        }),
        watch: {},
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            enableBtn() {
                console.log("hi...");
            },  
//by vrushali 
            locatorButtonPressed() {
                this.loader = true;
            let obj = this
            if(navigator.geolocation){
                navigator.geolocation.getCurrentPosition(position => {
                    console.log("latitude")
                    obj.latitude = position.coords.latitude
                   // alert(obj.latitude)
                    obj.longitude = position.coords.longitude
                    //alert(obj.longitude)
                    console.log(position.coords.latitude);
                     console.log("longitude")
                    console.log(position.coords.longitude);
                    obj.checkExam()
                },
                error =>{
                    console.log(error.message)
                    obj.checkExam()
                }
                );         
            }
            else{
                console.log("Geolocation is not supported by this browser")
                obj.checkExam()
            }
        }, 
//by vrushali 
            checkExam() {
               
                //alert(this.longitude)
                const formData = {
                    ett_id: this.ettid_list,
                    latitude : this.latitude,
                    longitude: this.longitude
                };
                this.loader = true;
                axios
                    .post("/student/checkExam", formData)
                    .then((res) => {
                        // alert("invalidquecheck ::"+res.data.invalidquecheck)
                        if (res.data.status == "NO") {
                            // this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.dialog = true;
                            this.msg = res.data.snackbar;
                        } else {
                            //vrushali code start
                             if(res.data.whiteboard_config == "YES"){
                                this.whiteboard_config = true
                            }
                            else{
                               this.whiteboard_config = false
                            }
                            //vrushali code end
                            if(res.data.calculator_config == "YES"){
                                this.calculator_config = true
                            }
                            else{
                               this.calculator_config = false
                            }
                            localStorage.setItem("stud_ques_ans_list", JSON.stringify(res.data.stud_ques_ans_list));
                            localStorage.setItem("les", JSON.stringify(res.data.les));
                            localStorage.setItem("ans_status", JSON.stringify(res.data.ans_status));
                            localStorage.setItem("supervisionlink", JSON.stringify(res.data.supervisionlink));
                            localStorage.setItem("show-result", JSON.stringify(res.data.resultFlag));
                            localStorage.setItem("invalidQuestionCheck", JSON.stringify(res.data.invalidquecheck));
                            // console.log(res.data.stud_ques_ans_list)
                            // console.log(localStorage.getItem("stud_ques_ans_list"))

                            this.TAB_SWITCHING = res.data.TAB_SWITCHING
                            this.$router.push({ name: "stud-exam" , params: { show_whitebord: this.whiteboard_config,show_calculator: this.calculator_config ,TAB_SWITCHING:this.TAB_SWITCHING }});

                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            capture(){
                // console.log("1111")
                // console.log(this.stud)
                this.$router.push({ name: "capture-pic", params: { learner: this.stud ,ett_list : this.ettid_list}});
            }
        },
        mounted() {
            // document.addEventListener('contextmenu', event => event.preventDefault());
            localStorage.setItem("stud_ques_ans_list", "");
            localStorage.setItem("les", "");
            localStorage.setItem("ans_status", "");
            localStorage.setItem("invalidQuestionCheck", "");
            localStorage.setItem("interval", 10000);
            axios
                .post("/student/startExam")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.stud = res.data.stud;
                        this.col_list = res.data.col_list;
                        this.exam_instructions = res.data.exam_instructions;
                        this.exam_course_data = res.data.exam_course_data;
                        this.ettid_list = res.data.ettid_list;
                        this.icard = res.data.i_card;
                        this.exam_inst = res.data.exam_inst_List;
                        localStorage.setItem("interval", res.data.interval);
                        //timer
                        this.enableBtn();
                        // this.timer = setInterval(this.enableBtn, 60000)
                        if (res.data.status == "NO") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                        } else {
                        }
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {});
        },
        beforeDestroy() {
            console.log("destroy");
            clearInterval(this.timer);
        },
    };
</script>
<style scoped>
    .bg {
        background: blanchedalmond;
    }
    .blink_me {
        white-space: nowrap;
        color: red;
        animation: blinker 1s linear infinite;
    }

    @keyframes blinker {
        50% {
            opacity: 0;
        }
    }
    .new5 {
        border: 2px solid #049bc9;
    }
    .trclass {
        background: lightsalmon;
        color: #fff;
    }
</style>
